<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import {
  NXGDSNavigationItem,
  NXGDSNavigationPanel,
  type NXGDSNavigationItemModel
} from '@nsftx/seven-nxg-design-system'
import router from '@/router'

const { t } = useI18n()
// TODO: Uncomment when the card operations, tickets, wallet are implemented
const sidebarMenuItems = ref<NXGDSNavigationItemModel[]>([
  // {
  //   uuid: 'cardOperations',
  //   title: t('backoffice_card_operations')
  // },
  // {
  //   uuid: 'tickets',
  //   title: t('backoffice_tickets')
  // },
  // {
  //   uuid: 'wallet',
  //   title: t('backoffice_wallet')
  // },
  {
    uuid: 'reporting',
    title: t('backoffice_reporting')
  },
  {
    uuid: 'settings',
    title: t('backoffice_settings')
  },
  // {
  //   uuid: 'certificate',
  //   title: t('backoffice_certificate')
  // },
  {
    uuid: 'about',
    title: t('backoffice_about')
  }
])

const isSidebarItemActive = (
  itemUuid: string,
  currentRouteName: string | symbol | null | undefined
) => {
  if (itemUuid === 'settings') {
    return String(currentRouteName).startsWith('settings')
  }

  if (itemUuid === 'reporting') {
    return String(currentRouteName).startsWith('reporting')
  }

  return itemUuid === currentRouteName
}

onMounted(async () => {
  await router.isReady()
  const currentName = router.currentRoute.value.name
  const activeItem = sidebarMenuItems.value.find((item) =>
    isSidebarItemActive(item.uuid, currentName)
  )
  if (activeItem) activeItem.state = 'active'
})

const handleClick = (item: NXGDSNavigationItemModel) => {
  sidebarMenuItems.value.forEach((item) => (item.state = 'default'))
  item.state = 'active'
  router.push({ name: item.uuid })
}
</script>
<template>
  <aside class="sbo-sidebar">
    <NXGDSNavigationPanel v-model="sidebarMenuItems">
      <template #item="{ item }">
        <NXGDSNavigationItem
          :title="item.title"
          :state="item.state"
          size="md"
          :icon-name="item.iconName"
          @click="handleClick(item)"
        />
      </template>
    </NXGDSNavigationPanel>
  </aside>
</template>
<style scoped>
.sbo-sidebar {
  padding: var(--nxgds-alias-spacing-lg);
}
</style>
